export default __webpack_public_path__ + "static/media/off-thepitch-gray.d308b3da.svg";